var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Breadcrumb',[_c('BreadcrumbItem',{attrs:{"to":"/"}},[_vm._v("首页")]),_c('BreadcrumbItem',{attrs:{"list":_vm.list,"to":_vm.to}},[_vm._v(_vm._s(_vm.list))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }